export default __webpack_public_path__ + "static/media/daydream-image.148c64ba.png";